import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { FormattedMessage } from 'react-intl';
import { TransactionalSolidButton } from '@bibliocommons/base-buttons';
import { userIdentityShape } from '@bibliocommons/bc-prop-types';
import RadioButton from 'app/components/shared/RadioButton';
import { ChevronLink } from '@bibliocommons/base-links';
import { ModalHeader, ModalContent, ModalFooter } from 'app/components/shared/Modal';
import { FLAG_TYPES } from 'app/constants/FlagsConstants';
import StandardsViolationForm from './StandardsViolationForm';
import OffensiveContentForm from './OffensiveContentForm';
import SpoilersForm from './SpoilersForm';
import './FlagUgcForm.scss';

export default class FlagUgcForm extends React.PureComponent {
  state = {
    flagTypeIsSet: false,
    selectedFlagType: null
  };

  flagUgc = ({ violationType, offensiveDetails }) => {
    const { id, flagsActions, user, handleClose } = this.props;
    const { selectedFlagType } = this.state;

    flagsActions.addFlag({
      contentId: id,
      userId: user.get('id'),
      flagType: selectedFlagType,
      reason: offensiveDetails,
      violationType,
      postSuccess: handleClose
    });
  };

  handleFlagTypeChange = value => this.setState({ selectedFlagType: value });

  handleFlagTypeSubmit = () => {
    this.setState({ flagTypeIsSet: true });
  };

  renderSelectOptionForm = () => {
    const { flags, id } = this.props;

    return (
      <div className="select-option-form">
        <ModalHeader title={<FormattedMessage id="flag_content" />} />
        <ModalContent>
          <span className="select-option" id="select-option-label">
            <FormattedMessage id="select_option" />
          </span>
          <ul className="flag-types-list" role="radiogroup" aria-labelledby="select-option-label">
            {Object.values(FLAG_TYPES).map(flagType => {
              const optionIsDisabled = !flags.getIn([id.toString(), 'flaggableTypes'], []).includes(flagType);
              const disabledNotice = optionIsDisabled && (
                <span className="already-flagged">
                  <FormattedMessage id="already_flagged" />
                </span>
              );
              return (
                <li key={flagType}>
                  <RadioButton
                    checked={this.state.selectedFlagType === flagType}
                    disabled={optionIsDisabled}
                    handleChange={this.handleFlagTypeChange}
                    id={`select-${flagType}`}
                    label={<FormattedMessage id={`contains_${flagType.toLowerCase()}`} />}
                    name="select-flag-type"
                    value={flagType}
                    dataKey={`select-${flagType}`}
                  />
                  {disabledNotice}
                </li>
              );
            })}
          </ul>
          <ChevronLink
            href="https://help.bibliocommons.com/025ug/060reporting-inappropriate-content/"
            dataKey="find-out-more-link"
          >
            <FormattedMessage id="find_out_more_link" />
          </ChevronLink>
        </ModalContent>
        <ModalFooter
          primaryActionButtonText={<FormattedMessage id="next" />}
          primaryActionButtonTag={TransactionalSolidButton}
          handlePrimaryAction={this.handleFlagTypeSubmit}
          disabled={!this.state.selectedFlagType}
        />
      </div>
    );
  };

  renderDetailsForm = () => {
    const { id, flagsTransactions } = this.props;
    const isLoading = flagsTransactions.getIn([id, 'isAdding']);

    switch (this.state.selectedFlagType) {
      case FLAG_TYPES.STANDARDS_VIOLATION:
        return <StandardsViolationForm handleSubmit={this.flagUgc} isLoading={isLoading} />;
      case FLAG_TYPES.OFFENSIVE:
        return <OffensiveContentForm handleSubmit={this.flagUgc} isLoading={isLoading} />;
      case FLAG_TYPES.SPOILER:
        return <SpoilersForm handleSubmit={this.flagUgc} isLoading={isLoading} />;
      default:
        return null;
    }
  };

  render() {
    return (
      <div className="cp-flag-ugc-form">
        {this.state.flagTypeIsSet ? this.renderDetailsForm() : this.renderSelectOptionForm()}
      </div>
    );
  }
}

FlagUgcForm.propTypes = {
  id: PropTypes.number.isRequired,
  handleClose: PropTypes.func,
  user: userIdentityShape,
  flags: ImmutablePropTypes.map.isRequired,
  flagsActions: PropTypes.objectOf(PropTypes.func).isRequired,
  flagsTransactions: ImmutablePropTypes.map.isRequired
};
